import cx from 'classnames';
import PropTypes from 'prop-types';
import formatPrice from '@bwoty-web/price-formatter';
import { useMemo } from 'react';
import { Button } from '@bwoty-web/ui-kit';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

import KeySellingPointList from '../../common/keySellingPointList';

import './PackagePlusInfoView.scss';

const PackagePlusInfoView = ({
  geoPackagePlusInfo: {
    classificationList,
    countryName,
    resortName,
    tripRuleName,
  },
  labels,
  price = '',
  siteId,
}) => {
  const isGlobetrotter = useIsGlobetrotter();

  const locationStr = useMemo(() => {
    let locationString = '';
    if (resortName && countryName)
      locationString = `${resortName}, ${countryName}`;
    else if (resortName) locationString = resortName;
    else if (countryName) locationString = countryName;
    return locationString;
  }, [countryName, resortName]);

  return (
    <div className="geo-package-plus__container uikit-box">
      <div>
        <h1 className="geo-package-plus__heading">{tripRuleName}</h1>
        {locationStr && (
          <p className="geo-package-plus__location">{locationStr}</p>
        )}
        <KeySellingPointList
          checkmark={!isGlobetrotter}
          className="geo-package-plus__tags-container"
          ksps={classificationList}
          limit={0}
        />
      </div>
      <div className="geo-package-plus__right-section">
        {price && (
          <div className="geo-package-plus__price-wrapper">
            <span className="geo-package-plus__from-price-label">
              {labels?.packagePlusFromPrice}
            </span>
            <span
              className={cx('geo-package-plus__price', {
                'geo-package-plus__price--red': ![1, 18].includes(Number(siteId)),
              })}
            >
              {formatPrice(price, siteId, true)}
            </span>
          </div>
        )}
        <Button href="#Search-And-Summary" variant="primary">
          {labels?.bookBtnLabel}
        </Button>
      </div>
    </div>
  );
};

PackagePlusInfoView.propTypes = {
  geoPackagePlusInfo: PropTypes.shape({
    classificationList: PropTypes.arrayOf(PropTypes.string),
    countryName: PropTypes.string,
    resortName: PropTypes.string,
    tripRuleName: PropTypes.string,
  }).isRequired,
  labels: PropTypes.shape({
    bookBtnLabel: PropTypes.string,
    packagePlusFromPrice: PropTypes.string,
  }).isRequired,
  price: PropTypes.string,
  siteId: PropTypes.string.isRequired,
};

export default PackagePlusInfoView;
